module.exports = __webpack_public_path__ + "res/Roboto-Medium-webfont.woff?c39e6597c213e4bec6766ae594d6bb49";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto/Roboto-Medium-webfont.woff
// module id = 73
// module chunks = 0